import * as React from "react";
import { styled } from "@mui/material/styles";
import MuiMenuItem from "@mui/material/MenuItem";
import ListItemIcon, { listItemIconClasses } from "@mui/material/ListItemIcon";
import LogoutRoundedIcon from "@mui/icons-material/LogoutRounded";
import { useNavigate } from "react-router-dom";

const MenuItem = styled(MuiMenuItem)({
  margin: "2px 0",
});

export default function OptionsMenu() {
  const navigate = useNavigate();

  const handleLogout = () => {
    // Tüm localStorage'ı temizle
    localStorage.clear();

    navigate("/login");
  };

  return (
    <React.Fragment>
      <MenuItem
        onClick={handleLogout}
        sx={{
          [`& .${listItemIconClasses.root}`]: {
            ml: "auto",
            minWidth: 0,
          },
          borderColor: "transparent",
        }}
      >
        <ListItemIcon>
          <LogoutRoundedIcon fontSize="small" />
        </ListItemIcon>
      </MenuItem>
    </React.Fragment>
  );
}
